import React from "react";
import useProfilNCBContent from "./hooks/useProfilNCBContent";

const OrganizationalStructureContent = () => {
  const {
    // State
    expandedSections,
    selectedNode,
    // showChart,
    // chartRef,

    // Data
    departments,

    // Actions
    toggleSection,
    handleNodeClick,
    // setShowChart,
  } = useProfilNCBContent();

  return (
    <>
      {/* Introduction Section */}
      <div className="p-8">
        <div className="bg-opacity-50 bg-info border border-opacity-20 border-base-content rounded-xl p-6 mb-8 shadow-sm">
          <div className="flex items-start gap-x-4">
            <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-primary-content text-xl">ℹ️</span>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-base-content mb-4">
                Set NCB Interpol Indonesia
              </h2>
              <p className="text-base-content opacity-80 leading-relaxed mb-4">
                Set NCB Interpol Indonesia merupakan unsur pelaksana utama yang
                berada di bawah Kadivhubinter Polri. Set NCB Interpol Indonesia
                bertugas membina, mengawasi dan mengendalikan penyelenggaraan
                tugas NCB Interpol Indonesia, komunikasi dan pertukaraan
                informasi melalui sistem jaringan Interpol dan Aseanapol, serta
                kerja sama internasional di wilayah perbatasan dalam rangka
                penanggulangan kejahatan transnasional/internasional.
              </p>
              <div className="bg-primary bg-opacity-10 rounded-lg p-4 border-l-4 border-primary shadow-sm">
                <p className="text-base-content opacity-90 font-medium">
                  Dalam melaksanakan tugas dan tanggung jawab, Set NCB Interpol
                  Indonesia dibantu oleh
                  <span className="font-bold text-primary">
                    {" "}
                    3 (tiga) bagian utama
                  </span>{" "}
                  dan
                  <span className="font-bold text-primary">
                    {" "}
                    1 urusan tata usaha
                  </span>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Organizational Structure Chart */}
        <div className="bg-base-100 text-base-content rounded-xl p-6 mb-8 border border-base-300 shadow-lg">
          <div className="mb-6">
            <h3 className="text-2xl font-bold text-base-content mb-4">
              🏗️ Struktur Organisasi Set NCB Interpol
            </h3>
          </div>

          <div className="w-full">
            <div className="flex justify-center items-center bg-base-200 rounded-lg p-6 border border-base-300 shadow-inner">
              <img
                src="/static/struktur-organisasi-ncb.png"
                alt="Struktur Organisasi NCB Interpol Indonesia"
                className="max-w-full h-auto rounded-lg shadow-md"
                style={{ maxHeight: "600px" }}
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "block";
                }}
              />
              <div
                className="text-center p-8 text-base-content/70"
                style={{ display: "none" }}
              >
                <div className="text-4xl mb-4">📊</div>
                <p className="text-base-content/80">
                  Gambar struktur organisasi sedang dimuat...
                  <br />
                  Silakan pastikan file gambar tersedia di public/static/
                </p>
              </div>
            </div>
            <div className="mt-4 text-center">
              <div className="bg-info/20 rounded-lg p-4 mb-4">
                <p className="text-sm text-base-content/80 mb-2">
                  💡 <strong>Struktur Organisasi NCB Interpol Indonesia</strong>
                </p>
                <p className="text-xs text-base-content/70">
                  Klik pada bagian di bawah ini untuk melihat detail setiap
                  departemen
                </p>
              </div>
              {selectedNode && (
                <div className="inline-flex items-center gap-x-2 bg-primary/20 text-primary px-4 py-2 rounded-lg">
                  <span className="w-2 h-2 bg-primary rounded-full animate-pulse"></span>
                  <span className="text-sm font-medium">
                    Dipilih:{" "}
                    {departments.find((d) => d.id === selectedNode)?.subtitle ||
                      selectedNode}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Quick Overview Cards */}
        <div className="grid grid-cols-1 laptop:grid-cols-3 gap-x-4 gap-y-4 mb-8">
          {departments.map((dept) => (
            <div
              key={dept.id}
              className={`bg-base-100 text-base-content rounded-lg p-4 shadow-md border-l-4 hover:shadow-xl transition-all duration-200 cursor-pointer ${
                selectedNode === dept.id
                  ? "ring-2 ring-primary border-primary bg-primary/10"
                  : "border-base-300 hover:border-primary"
              }`}
              onClick={() => {
                handleNodeClick(dept.id);
                toggleSection(dept.id);
              }}
            >
              <div className="text-center">
                <div className="text-3xl mb-2">{dept.icon}</div>
                <div className="text-sm font-semibold text-base-content leading-tight">
                  {dept.subtitle}
                </div>
                <div className="text-xs text-base-content/70 mt-1">
                  Klik untuk detail
                </div>
              </div>
            </div>
          ))}
          <div className="laptop:col-span-3 flex justify-center">
            <div className="bg-base-100 text-base-content border border-base-300 px-6 py-3 rounded-lg font-semibold hover:shadow-md transition-all duration-200">
              📋 Urusan Tata Usaha (Urtu)
            </div>
          </div>
        </div>
      </div>

      {/* Departments Detail */}
      <div className="space-y-6 px-8 pb-8">
        {departments.map((dept, index) => (
          <div
            key={dept.id}
            id={`section-${dept.id}`}
            className={`bg-base-100 text-base-content rounded-2xl shadow-xl border border-base-300 overflow-hidden transition-all duration-300 ${
              selectedNode === dept.id ? "ring-4 ring-primary/30" : ""
            }`}
          >
            <div
              className={`bg-gradient-to-r ${dept.color} px-8 py-6 cursor-pointer hover:opacity-90 transition-opacity`}
              onClick={() => toggleSection(dept.id)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  toggleSection(dept.id);
                }
              }}
              aria-expanded={expandedSections[dept.id]}
              aria-controls={`section-${dept.id}`}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-x-4">
                  <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center">
                    <span className="text-2xl">{dept.icon}</span>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white">
                      ({index + 1}) {dept.title}
                    </h3>
                    <p className="text-white/90 text-lg">{dept.subtitle}</p>
                  </div>
                </div>
                <div className="flex items-center gap-x-4">
                  {selectedNode === dept.id && (
                    <div className="bg-white/20 px-3 py-1 rounded-full">
                      <span className="text-white text-sm font-medium">
                        Terpilih
                      </span>
                    </div>
                  )}
                  <div
                    className="text-white text-2xl transform transition-transform duration-200"
                    style={{
                      transform: expandedSections[dept.id]
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  >
                    ▼
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`transition-all duration-300 overflow-hidden ${
                expandedSections[dept.id]
                  ? "max-h-none opacity-100"
                  : "max-h-0 opacity-0"
              }`}
            >
              <div className="p-8">
                {/* Description */}
                <div className="mb-8">
                  <h4 className="text-xl font-bold text-base-content mb-4 flex items-center gap-x-2">
                    <span className="w-2 h-2 bg-primary rounded-full"></span>
                    Tugas, Fungsi, dan Peran
                  </h4>
                  <p className="text-base-content opacity-80 leading-relaxed bg-info bg-opacity-30 p-4 rounded-lg border border-opacity-20 border-base-content">
                    {dept.description}
                  </p>
                </div>

                {/* Functions */}
                <div className="mb-8">
                  <h4 className="text-xl font-bold text-base-content mb-4 flex items-center gap-x-2">
                    <span className="w-2 h-2 bg-success rounded-full"></span>
                    Fungsi Utama
                  </h4>
                  <div className="grid grid-cols-1 laptop:grid-cols-2 gap-x-4 gap-y-3">
                    {dept.functions.map((func, idx) => (
                      <div
                        key={idx}
                        className="flex items-start gap-x-3 bg-info bg-opacity-20 text-base-content border border-opacity-20 border-base-content rounded-lg p-4 hover:shadow-md transition-all duration-200"
                      >
                        <div
                          className={`w-8 h-8 ${dept.borderColor} border-2 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5`}
                        >
                          <span className="text-sm font-bold text-base-content opacity-70">
                            {idx + 1}
                          </span>
                        </div>
                        <p className="text-base-content opacity-90 text-sm leading-relaxed">
                          {func}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Subunits */}
                <div>
                  <h4 className="text-xl font-bold text-base-content mb-4 flex items-center gap-x-2">
                    <span className="w-2 h-2 bg-secondary rounded-full"></span>
                    Unit Pelaksana
                  </h4>
                  <div className="grid grid-cols-1 laptop:grid-cols-2 desktop:grid-cols-3 gap-x-4 gap-y-3">
                    {dept.subunits.map((unit, idx) => (
                      <div
                        key={idx}
                        className="bg-info bg-opacity-20 rounded-lg p-4 border border-opacity-20 border-base-content hover:bg-primary/5 hover:border-primary/40 hover:shadow-md transition-all duration-200"
                      >
                        <div className="flex items-center gap-x-3">
                          <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
                            <span className="text-primary-content text-sm font-bold">
                              {idx + 1}
                            </span>
                          </div>
                          <p className="text-base-content font-medium text-sm leading-tight">
                            {unit}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* Urusan Tata Usaha */}
        <div className="bg-base-100 text-base-content rounded-2xl shadow-xl border border-base-300 overflow-hidden">
          <div className="bg-gradient-to-r from-neutral to-neutral-focus px-8 py-6">
            <div className="flex items-center gap-x-4">
              <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center">
                <span className="text-2xl">📋</span>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-neutral-content">
                  (4) Urusan Tata Usaha
                </h3>
                <p className="text-neutral-content/80 text-lg">(Urtu)</p>
              </div>
            </div>
          </div>
          <div className="p-8">
            <div className="bg-info bg-opacity-20 border border-opacity-20 border-base-content rounded-lg p-6 text-center">
              <div className="text-4xl mb-4">📊</div>
              <p className="text-base-content opacity-80 font-medium">
                Urusan Tata Usaha mengelola administrasi dan mendukung
                operasional seluruh bagian dalam Set NCB Interpol Indonesia.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrganizationalStructureContent;
